import { Component, inject, OnInit, DestroyRef, ChangeDetectionStrategy, afterNextRender, ViewChild, ElementRef } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MessageService } from './shared/services/message/message.service';
import { StoreService } from './shared/services/store/store.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StyleService } from './shared/services/style/style.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { ResizeReporter } from './shared/services/resize-reporter/resize-reporter.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule, SpinnerComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  // Injected dependencies
  private readonly messageService = inject(MessageService);
  private readonly storeService = inject(StoreService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly styleService = inject(StyleService);
  private readonly resizeReporter = inject(ResizeReporter);

  @ViewChild('app', { static: true })
  app!: ElementRef<HTMLElement>;

  // Loading signals (render the page as spinning)
  public isLoading = this.styleService.isLoading;

  constructor() {
    // Listen to host open messages and populate the store service
    toObservable(this.messageService.hostOpen)
      .pipe(
        filter((msg) => msg != undefined),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((msg) => {
        if (msg != null) this.storeService.setSessionId(msg.sessionId);
      });

    // Report size changes
    afterNextRender(() => this.resizeReporter.start(this.app.nativeElement));
  }

  ngOnInit(): void {
    this.messageService.ready();
  }
}
